/* eslint-disable quotes */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChatBoardHeader from "./chatboard/chatboardHeader";
import ChatBoardBody from "./chatboard/chatboardBody";
import ChatBoardFooter from "./chatboard/chatboardFooter";
import ChatBoardWelcome from "./chatboard/ChatboardWelcome";
import { getAuthSession, getObjectLength } from "./Helpers/common";
import { _getUpdatedChatMessage } from "../SocketIo";
import { setWelcomeBoard } from "./redux/authUserDetail";
import { setActiveThreadChat, setAttendeeData } from "./redux/chatSlice";
import ThreadboardBody from "./threadboard/threadboardBody";
import ThreadboardHeader from "./threadboard/threadboardHeader";
import { useSearchParams } from "react-router-dom";
import { clearUnreadThreadCount, openUserChat } from "./Helpers/chatCommon";
import { MessageDetailIcon } from "../assets/icons/svg";
import ThreadboardFooter from "./threadboard/threadboardFooter";
import ProgressBar from "./chatboard/progressBar";

const ChatBoard = () => {
  const dispatch = useDispatch();
  const [chatWidth, setChatWidth] = useState(60);
  const [isResizing, setIsResizing] = useState(false);
  const { user_unique_key: senderID } = getAuthSession();

  const { authUserDetail, chat, call } = useSelector((state) => state);

  const { welcomeBoard } = authUserDetail || {};

  const {
    attendeeData,
    groupList,
    selectedLanguage,
    chatboardSelectedTab,
    activeThreadChat,
    chatRoom,
    attendeeList,
    progressThread = 0,
  } = chat || {};

  const { allAttendeeList } = call || {};

  const UserData = attendeeData || {};

  const [searchParams, setSearchParams] = useSearchParams();
  const chatRoomParam = searchParams.get("chatroom");
  const isGroupNotification = searchParams.get("type") === "group";
  const parentMsgId = searchParams.get("parent_id");
  // const threadId = searchParams.get("thread_id");

  const isInThread = Object.keys(activeThreadChat).includes(chatRoom);

  React.useEffect(() => {
    if (getObjectLength(attendeeData)) {
      if (attendeeData?.type == "group") {
        const selectedData = groupList.find(
          (item) => item?.groupId === attendeeData?.groupId,
        );
        if (selectedData === undefined) {
          dispatch(setAttendeeData({}));
        } else {
          const userNameData = [];
          selectedData?.attendeeId?.forEach((item) => {
            const filterUsername = allAttendeeList?.filter(
              (v) => v?.user_id === item,
            );
            if (filterUsername && filterUsername.length > 0) {
              userNameData.push(filterUsername[0].name);
            }
          });
          const username =
            userNameData?.length > 0 ? userNameData.toString() : "";
          dispatch(
            setAttendeeData({ ...selectedData, type: "group", username }),
          );
        }
      } else {
        const selectedData = allAttendeeList.find(
          (item) => item.user_id === attendeeData?.user_id,
        );
        dispatch(
          setAttendeeData(
            selectedData === undefined
              ? {}
              : {
                  ...selectedData,
                  role_name: selectedData.role,
                  type: "attendee",
                },
          ),
        );
      }
    }
  }, [allAttendeeList, groupList]);

  useEffect(() => {
    if (getObjectLength(attendeeData)) {
      if (attendeeData?.type == "attendee") {
        dispatch(setWelcomeBoard(true));
      } else {
        if (
          attendeeData?.attendeeId?.includes(senderID) &&
          attendeeData?.type == "group"
        ) {
          dispatch(setWelcomeBoard(true));
        } else {
          dispatch(setWelcomeBoard(false));
        }
      }
    } else {
      dispatch(setWelcomeBoard(false));
    }
  }, [attendeeData]);

  useEffect(() => {
    _getUpdatedChatMessage(senderID);
  }, []);

  useEffect(() => {
    if (chatRoomParam) {
      //For Private Msg Notification
      if (attendeeList && !isGroupNotification) {
        console.log("For Private Msg Notification");
        const paramAttendeeData = attendeeList?.find((v) =>
          chatRoomParam?.split("_")?.includes(v?.user_id),
        );
        openUserChat(paramAttendeeData, isGroupNotification);
      }
      //For Group Msg Notification
      if (groupList?.length > 0 && isGroupNotification) {
        console.log("For Group Msg Notification");

        const paramGroupData = groupList?.find(
          (v) => v?.groupId === chatRoomParam,
        );
        openUserChat(paramGroupData, isGroupNotification);
      }

      //For thread Notification
      if (parentMsgId && parentMsgId != "undefined" && parentMsgId != "null") {
        dispatch(
          setActiveThreadChat({
            documentID: chatRoomParam,
            id: parentMsgId,
          }),
        );
      }

      setSearchParams({});
      clearUnreadThreadCount(chatRoomParam, parentMsgId, UserData?.company_id);
    }
  }, [chatRoomParam, attendeeList, parentMsgId, groupList]);

  const startResize = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsResizing(true);
    document.body.style.cursor = "col-resize";

    const startX = e.clientX;
    const startWidth = chatWidth;

    const onMouseMove = (moveEvent) => {
      const delta = moveEvent.clientX - startX;
      const screenWidth = window.innerWidth;

      let newWidth = startWidth + (delta / screenWidth) * 100;
      newWidth = Math.max(33, Math.min(67, newWidth));

      setChatWidth(newWidth);
    };

    const onMouseUp = () => {
      setIsResizing(false);
      document.body.style.cursor = "default";
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <>
      {welcomeBoard ? (
        <div className={`right_s ${isInThread ? "d-flex w-full" : ""}`}>
          {/* {showThreadSection ? (
            <div
              className="chat_box"
              style={{ width: isInThread ? `${chatWidth}%` : "100%" }}
            >
              <div className="head p-3">
                <div className="name">Threads</div>
              </div>
              <div className="body body-inner flex-column">
                <div id="chat-feed" className="chat-feed overflow-auto gap-4">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center gap-1">
                        <LockIcon width={"16"} />
                        <strong>Test-dev</strong>
                      </div>
                      <div className="time mb-0">Test, Tester and 3 others</div>
                    </div>
                    <div className="border border-light bg-light-10 border-radius mt-2 cursor-pointer d-flex flex-column p-2">
                      <div className="chat_row w-100">
                        <div className="w-100 d-flex flex-column max-w-100">
                          <div className="d-flex">
                            <div className="avatar">
                              <img
                                className="h-100"
                                src="https://app.c2perform.com/files1/user-pics/404/04222025105105avatar.jpg"
                                alt=""
                              />
                              <span className="status online"></span>
                            </div>
                            <div className="bubble inner-bubble false">
                              <div className="false">
                                <h3 className="Name-messenger">
                                  Chirag Kumar{" "}
                                  <div className="time">Jan 15, 1:02 PM</div>
                                </h3>
                              </div>
                              <div className="d-flex justify-content-between gap-10 align-items-start">
                                <div className="d-flex file_send_info gap-10 flex-wrap">
                                  <p className="break-words">12</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace">
                                  <span>view thread replies</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat_actions display_none">
                          <div className="chat_actions_span">
                            <button
                              type="submit"
                              className="btn-icon justify-content-center"
                            >
                              <svg width="19" height="19" viewBox="2 2 20 20">
                                <path
                                  fill="#b8c0c9"
                                  d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                                ></path>
                                <path
                                  fill="#b8c0c9"
                                  d="M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                                ></path>
                                <circle
                                  fill="#b8c0c9"
                                  cx="8.5"
                                  cy="10.5"
                                  r="1.5"
                                ></circle>
                                <circle
                                  fill="#b8c0c9"
                                  cx="15.493"
                                  cy="10.493"
                                  r="1.493"
                                ></circle>
                              </svg>
                            </button>
                            <div className="dropdown">
                              <a
                                className="justify-content-center dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                href="void:0"
                              >
                                <svg width="4px" viewBox="10 4 4 16">
                                  <path
                                    fill="#b8c0c9"
                                    d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                                  ></path>
                                </svg>
                              </a>
                              <ul
                                className="chat_actions_dropdown flex-column dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Edit
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply in thread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Delete
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Mark unread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Pin
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="chat_row w-100">
                        <div className="w-100 d-flex flex-column max-w-100">
                          <div className="d-flex">
                            <div className="avatar">
                              <img
                                className="h-100"
                                src="https://app.c2perform.com/files1/user-pics/404/04222025105105avatar.jpg"
                                alt=""
                              />
                              <span className="status online"></span>
                            </div>
                            <div className="bubble inner-bubble false">
                              <div className="false">
                                <h3 className="Name-messenger">
                                  Chirag Kumar{" "}
                                  <div className="time">Jan 15, 1:02 PM</div>
                                </h3>
                              </div>
                              <div className="d-flex justify-content-between gap-10 align-items-start">
                                <div className="d-flex file_send_info gap-10 flex-wrap">
                                  <p className="break-words">12</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace">
                                  <span>view thread replies</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat_actions display_none">
                          <div className="chat_actions_span">
                            <button
                              type="submit"
                              className="btn-icon justify-content-center"
                            >
                              <svg width="19" height="19" viewBox="2 2 20 20">
                                <path
                                  fill="#b8c0c9"
                                  d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                                ></path>
                                <path
                                  fill="#b8c0c9"
                                  d="M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                                ></path>
                                <circle
                                  fill="#b8c0c9"
                                  cx="8.5"
                                  cy="10.5"
                                  r="1.5"
                                ></circle>
                                <circle
                                  fill="#b8c0c9"
                                  cx="15.493"
                                  cy="10.493"
                                  r="1.493"
                                ></circle>
                              </svg>
                            </button>
                            <div className="dropdown">
                              <a
                                className="justify-content-center dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                href="void:0"
                              >
                                <svg width="4px" viewBox="10 4 4 16">
                                  <path
                                    fill="#b8c0c9"
                                    d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                                  ></path>
                                </svg>
                              </a>
                              <ul
                                className="chat_actions_dropdown flex-column dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Edit
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply in thread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Delete
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Mark unread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Pin
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="chat_row mb-0 w-100">
                        <div className="w-100 d-flex flex-column max-w-100">
                          <div className="d-flex">
                            <div className="avatar">
                              <img
                                className="h-100"
                                src="https://app.c2perform.com/files1/user-pics/404/04222025105105avatar.jpg"
                                alt=""
                              />
                              <span className="status online"></span>
                            </div>
                            <div className="bubble inner-bubble false">
                              <div className="false">
                                <h3 className="Name-messenger">
                                  Chirag Kumar{" "}
                                  <div className="time">Jan 15, 1:02 PM</div>
                                </h3>
                              </div>
                              <div className="d-flex justify-content-between gap-10 align-items-start">
                                <div className="d-flex file_send_info gap-10 flex-wrap">
                                  <p className="break-words">12</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace">
                                  <span>view thread replies</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat_actions display_none">
                          <div className="chat_actions_span">
                            <button
                              type="submit"
                              className="btn-icon justify-content-center"
                            >
                              <svg width="19" height="19" viewBox="2 2 20 20">
                                <path
                                  fill="#b8c0c9"
                                  d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                                ></path>
                                <path
                                  fill="#b8c0c9"
                                  d="M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                                ></path>
                                <circle
                                  fill="#b8c0c9"
                                  cx="8.5"
                                  cy="10.5"
                                  r="1.5"
                                ></circle>
                                <circle
                                  fill="#b8c0c9"
                                  cx="15.493"
                                  cy="10.493"
                                  r="1.493"
                                ></circle>
                              </svg>
                            </button>
                            <div className="dropdown">
                              <a
                                className="justify-content-center dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                href="void:0"
                              >
                                <svg width="4px" viewBox="10 4 4 16">
                                  <path
                                    fill="#b8c0c9"
                                    d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                                  ></path>
                                </svg>
                              </a>
                              <ul
                                className="chat_actions_dropdown flex-column dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Edit
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply in thread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Delete
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Mark unread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Pin
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center gap-1">
                        <LockIcon width={"16"} />
                        <strong>Test-dev</strong>
                      </div>
                      <div className="time mb-0">Test, Tester and 3 others</div>
                    </div>
                    <div className="border border-light bg-light-10 border-radius mt-2 cursor-pointer d-flex flex-column p-2">
                      <div className="chat_row w-100">
                        <div className="w-100 d-flex flex-column max-w-100">
                          <div className="d-flex">
                            <div className="avatar">
                              <img
                                className="h-100"
                                src="https://app.c2perform.com/files1/user-pics/404/04222025105105avatar.jpg"
                                alt=""
                              />
                              <span className="status online"></span>
                            </div>
                            <div className="bubble inner-bubble false">
                              <div className="false">
                                <h3 className="Name-messenger">
                                  Chirag Kumar{" "}
                                  <div className="time">Jan 15, 1:02 PM</div>
                                </h3>
                              </div>
                              <div className="d-flex justify-content-between gap-10 align-items-start">
                                <div className="d-flex file_send_info gap-10 flex-wrap">
                                  <p className="break-words">12</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace">
                                  <span>view thread replies</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat_actions display_none">
                          <div className="chat_actions_span">
                            <button
                              type="submit"
                              className="btn-icon justify-content-center"
                            >
                              <svg width="19" height="19" viewBox="2 2 20 20">
                                <path
                                  fill="#b8c0c9"
                                  d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                                ></path>
                                <path
                                  fill="#b8c0c9"
                                  d="M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                                ></path>
                                <circle
                                  fill="#b8c0c9"
                                  cx="8.5"
                                  cy="10.5"
                                  r="1.5"
                                ></circle>
                                <circle
                                  fill="#b8c0c9"
                                  cx="15.493"
                                  cy="10.493"
                                  r="1.493"
                                ></circle>
                              </svg>
                            </button>
                            <div className="dropdown">
                              <a
                                className="justify-content-center dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                href="void:0"
                              >
                                <svg width="4px" viewBox="10 4 4 16">
                                  <path
                                    fill="#b8c0c9"
                                    d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                                  ></path>
                                </svg>
                              </a>
                              <ul
                                className="chat_actions_dropdown flex-column dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Edit
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply in thread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Delete
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Mark unread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Pin
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="chat_row w-100">
                        <div className="w-100 d-flex flex-column max-w-100">
                          <div className="d-flex">
                            <div className="avatar">
                              <img
                                className="h-100"
                                src="https://app.c2perform.com/files1/user-pics/404/04222025105105avatar.jpg"
                                alt=""
                              />
                              <span className="status online"></span>
                            </div>
                            <div className="bubble inner-bubble false">
                              <div className="false">
                                <h3 className="Name-messenger">
                                  Chirag Kumar{" "}
                                  <div className="time">Jan 15, 1:02 PM</div>
                                </h3>
                              </div>
                              <div className="d-flex justify-content-between gap-10 align-items-start">
                                <div className="d-flex file_send_info gap-10 flex-wrap">
                                  <p className="break-words">12</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace">
                                  <span>view thread replies</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat_actions display_none">
                          <div className="chat_actions_span">
                            <button
                              type="submit"
                              className="btn-icon justify-content-center"
                            >
                              <svg width="19" height="19" viewBox="2 2 20 20">
                                <path
                                  fill="#b8c0c9"
                                  d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                                ></path>
                                <path
                                  fill="#b8c0c9"
                                  d="M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                                ></path>
                                <circle
                                  fill="#b8c0c9"
                                  cx="8.5"
                                  cy="10.5"
                                  r="1.5"
                                ></circle>
                                <circle
                                  fill="#b8c0c9"
                                  cx="15.493"
                                  cy="10.493"
                                  r="1.493"
                                ></circle>
                              </svg>
                            </button>
                            <div className="dropdown">
                              <a
                                className="justify-content-center dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                href="void:0"
                              >
                                <svg width="4px" viewBox="10 4 4 16">
                                  <path
                                    fill="#b8c0c9"
                                    d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                                  ></path>
                                </svg>
                              </a>
                              <ul
                                className="chat_actions_dropdown flex-column dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Edit
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply in thread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Delete
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Mark unread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Pin
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="chat_row mb-0 w-100">
                        <div className="w-100 d-flex flex-column max-w-100">
                          <div className="d-flex">
                            <div className="avatar">
                              <img
                                className="h-100"
                                src="https://app.c2perform.com/files1/user-pics/404/04222025105105avatar.jpg"
                                alt=""
                              />
                              <span className="status online"></span>
                            </div>
                            <div className="bubble inner-bubble false">
                              <div className="false">
                                <h3 className="Name-messenger">
                                  Chirag Kumar{" "}
                                  <div className="time">Jan 15, 1:02 PM</div>
                                </h3>
                              </div>
                              <div className="d-flex justify-content-between gap-10 align-items-start">
                                <div className="d-flex file_send_info gap-10 flex-wrap">
                                  <p className="break-words">12</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace">
                                  <span>view thread replies</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat_actions display_none">
                          <div className="chat_actions_span">
                            <button
                              type="submit"
                              className="btn-icon justify-content-center"
                            >
                              <svg width="19" height="19" viewBox="2 2 20 20">
                                <path
                                  fill="#b8c0c9"
                                  d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                                ></path>
                                <path
                                  fill="#b8c0c9"
                                  d="M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                                ></path>
                                <circle
                                  fill="#b8c0c9"
                                  cx="8.5"
                                  cy="10.5"
                                  r="1.5"
                                ></circle>
                                <circle
                                  fill="#b8c0c9"
                                  cx="15.493"
                                  cy="10.493"
                                  r="1.493"
                                ></circle>
                              </svg>
                            </button>
                            <div className="dropdown">
                              <a
                                className="justify-content-center dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                href="void:0"
                              >
                                <svg width="4px" viewBox="10 4 4 16">
                                  <path
                                    fill="#b8c0c9"
                                    d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                                  ></path>
                                </svg>
                              </a>
                              <ul
                                className="chat_actions_dropdown flex-column dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Edit
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Reply in thread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Delete
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Mark unread
                                  </a>
                                </li>
                                <li className="chat_actions_li">
                                  <a className="chat_actions_tag" href="void:0">
                                    Pin
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : ( */}
          <div
            className="chat_box"
            style={{ width: isInThread ? `${chatWidth}%` : "100%" }}
          >
            <ChatBoardHeader />
            <div
              className={`body body-inner ${
                chatboardSelectedTab === "thread" && " flex-column"
              }`}
            >
              {getObjectLength(UserData) && <ChatBoardBody />}
            </div>
            {chatboardSelectedTab === "messages" && <ChatBoardFooter />}
          </div>
          {/* )} */}

          {isInThread && (
            <>
              <div
                className="resize-handle"
                onMouseDown={startResize}
                style={{
                  backgroundColor: isResizing && "#1e90ff",
                  width: isResizing && "3px",
                }}
              />
              <div
                className="thread_box border-left border-light h-100 d-flex flex-column position-relative"
                style={{ width: `${100 - chatWidth}%` }}
              >
                <ThreadboardHeader />

                <div className="tab-container">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={"nav-link d-flex align-items-center active"}
                        data-toggle="tab"
                        type="button"
                        role="tab"
                      >
                        <span className="mr-1 d-inline-flex align-items-center">
                          <MessageDetailIcon
                            width={16}
                            height={16}
                            className={"flip-icon"}
                          />
                        </span>
                        <strong>Replies</strong>
                      </button>
                    </li>
                  </ul>
                </div>

                {progressThread !== "" && (
                  <ProgressBar progress={progressThread} />
                )}

                <div className="body body-inner">
                  {getObjectLength(UserData) && <ThreadboardBody />}
                </div>
                <ThreadboardFooter isInThread={isInThread} />
              </div>
            </>
          )}
        </div>
      ) : (
        <div className="right_s">
          <div className="chat_box">
            <div className="body">
              <ChatBoardWelcome selectedLanguage={selectedLanguage} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatBoard;
